export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            精彩预告
          </h2>
          <p className="text-foreground-600 text-sm mt-2">最新影视预告与精彩片段，抢先感受大片魅力</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-video w-full relative bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20trailer%20moment%20with%20dramatic%20lighting%20and%20action%20scene%2C%20warm%20golden%20tones%2C%20epic%20film%20atmosphere%2C%20theatrical%20composition%2C%20movie%20poster%20aesthetic&width=640&height=360&seq=media-trailer-01&orientation=landscape"
                alt="流浪地球3 预告"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-12 h-12 rounded-full bg-background-950/50 flex items-center justify-center text-background-50 text-xl group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill"></i>
                </span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">流浪地球3 正式预告</h3>
              <p className="text-xs text-foreground-500 mt-0.5">2分30秒</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-video w-full relative bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20suspenseful%20film%20scene%20with%20moody%20atmospheric%20lighting%2C%20Korean%20drama%20cinematic%20style%2C%20warm%20dark%20tones%2C%20intense%20emotional%20moment%2C%20theatrical%20composition&width=640&height=360&seq=media-trailer-02&orientation=landscape"
                alt="黑暗荣耀 精彩片段"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-12 h-12 rounded-full bg-background-950/50 flex items-center justify-center text-background-50 text-xl group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill"></i>
                </span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">黑暗荣耀 高光时刻</h3>
              <p className="text-xs text-foreground-500 mt-0.5">4分12秒</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-video w-full relative bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20film%20scene%20with%20mythological%20creatures%20and%20warriors%2C%20dramatic%20golden%20lighting%2C%20grand%20cinematic%20scale%2C%20ancient%20Chinese%20aesthetic&width=640&height=360&seq=media-trailer-03&orientation=landscape"
                alt="封神第二部 预告"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-12 h-12 rounded-full bg-background-950/50 flex items-center justify-center text-background-50 text-xl group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill"></i>
                </span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">封神第二部 终极预告</h3>
              <p className="text-xs text-foreground-500 mt-0.5">3分05秒</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-video w-full relative bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20cinematic%20action%20scene%20with%20dynamic%20composition%20and%20warm%20dramatic%20lighting%2C%20Japanese%20animation%20aesthetic%2C%20intense%20battle%20moment%2C%20rich%20color%20contrast&width=640&height=360&seq=media-trailer-04&orientation=landscape"
                alt="鬼灭之刃 最终决战"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-12 h-12 rounded-full bg-background-950/50 flex items-center justify-center text-background-50 text-xl group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill"></i>
                </span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">鬼灭之刃 最终决战</h3>
              <p className="text-xs text-foreground-500 mt-0.5">5分48秒</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-video w-full relative bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20scene%20with%20warm%20nostalgic%20autumn%20lighting%2C%20Chinese%20small%20town%20atmosphere%2C%20suspenseful%20mood%2C%20film%20noir%20aesthetic%2C%20soft%20grain%20texture&width=640&height=360&seq=media-trailer-05&orientation=landscape"
                alt="漫长的季节 名场面"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-12 h-12 rounded-full bg-background-950/50 flex items-center justify-center text-background-50 text-xl group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill"></i>
                </span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">漫长的季节 经典片段</h3>
              <p className="text-xs text-foreground-500 mt-0.5">3分22秒</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}